// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { addressProps } from "@store/Themes/common/props/address";
import { orderProps } from "@store/Themes/common/props/order";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
/* Starter Custom Code */

interface OwnProps {
    shipTo: ShipToModel;
    onEdit: () => void;
    extendedStyles?: ShippingAddressInfoDisplayStyles;
}

export interface ShippingAddressInfoDisplayStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    editLink?: LinkPresentationProps;
    addressGridItem?: GridItemProps;
    address?: AddressInfoDisplayStyles;
}

export const shippingAddressInfoDisplayStyles: ShippingAddressInfoDisplayStyles = {
    heading: orderProps.subtitle,
    address: {
        wrapper: addressProps.wrapper,
    },
    editLink: addressProps.linkEdit,
};

const ShippingAddressInfoDisplay = ({ shipTo, onEdit, extendedStyles }: OwnProps) => {
    const styles = useMergeProps(shippingAddressInfoDisplayStyles, extendedStyles); // Starter Custom Code
    return (
        /* Store Custom Code - Start */
        <StyledWrapper data-test-selector="shippingAddressInfoDisplay_container">
            <Typography {...styles.heading}>{translate("Shipping Address")}</Typography>
            <AddressInfoDisplay
                {...shipTo}
                state={shipTo.state ? shipTo.state.abbreviation : undefined}
                country={shipTo.country ? shipTo.country.name : undefined}
                extendedStyles={styles.address}
            />
            {/* Foundation Removed Code */}
        </StyledWrapper>
        /* Store Custom Code - End */
    );
};

export default ShippingAddressInfoDisplay;
